export default __webpack_public_path__ + "static/media/loop_white_FA.116b24f2.svg";